import { TShortUrlAnalytics } from '@/types/TShortUrl';
import apiClient from '@/utils/apiClient';

const agentPrefix = '/agent/:agentId';
const REDIRECT_SHORT_URL_API_PATH = '/api/v2/receptionist-dashboard/short-url/redirect';
const SHORT_URL_ANALYTICS_API_PATH = `/api/v2/receptionist-dashboard${agentPrefix}/analytics/link-tracking`;

export const getShortURLRedirect = async (
	shortCode: string,
	encryptedKey: string | null,
): Promise<{
	success: boolean;
	originalURL?: string;
}> => {
	let query = '';
	if (encryptedKey) {
		query += `?encryptedKey=${encryptedKey}`;
	}

	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${REDIRECT_SHORT_URL_API_PATH}/${shortCode}${query}`,
	});

	return response;
};

export const getShortURLAnalytics = async (
	forwardedFrom: string,
	agentId: string,
): Promise<{ success: boolean; data: TShortUrlAnalytics }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${SHORT_URL_ANALYTICS_API_PATH.replace(':agentId', agentId)}/${forwardedFrom}`,
	});

	return response;
};
